export default __webpack_public_path__ + "static/ioi-1d69bea4648dda9982db8497f83f5b6d.jpg";